function Grid() {
	this.build();
	resizeCallbacks.push(this);
}

Grid.prototype.build = function () {

	const $gridlayout = $('.layout-grid');

	var isoOptions = {
		itemSelector: '.block',
		transitionDuration: 0,
		getSortData: {
			customOrder: '[data-order]',
		},
		sortBy: 'customOrder',
		masonry: {
			columnWidth: '.block',
			horizontalOrder: true
		}
	};

	if (window.innerWidth >= '768') {
		if ($gridlayout.hasClass('isotope-active')) {
			return;

		} else {
			let $grid = $gridlayout.isotope( isoOptions );
			$gridlayout.addClass('isotope-active');

			document.addEventListener('lazyloaded', function(e){
				$grid.isotope('layout');
			});
		}
	} else {
		if ($gridlayout.hasClass('isotope-active')) {
			$gridlayout.isotope('destroy');
			$gridlayout.removeClass('isotope-active');
		}
	}

};

Grid.prototype.resize = function () {
	this.build();
};